module.exports = "<div class=\"user-details-component user-ratings\">\r\n  <div class=\"title\">\r\n    <h4>\r\n      <span class=\"fa fa-star\"></span>\r\n      RATINGS\r\n    </h4>\r\n  </div>\r\n  <div class=\"details\">\r\n    <div class=\"ratings-grid\">\r\n      <div id=\"ratings-grid\" kendo-grid k-options=\"vm.gridOptions\"></div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/common/Components/user-ratings/user-ratings.html
 ** module id = 544
 ** module chunks = 0
 **/